import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/api";
import { useSelectedOrganization } from "@/hooks/useCurrentUser";

/** `logoUrl` is presigned per response (GetBrandsByOrganizationUseCase) and
 *  expires after an hour, so consumers remember a failed load per URL. Null
 *  when the brand has no logo; every consumer keeps its monogram fallback. */
export type Brand = { id: string; name: string; logoUrl?: string | null };

/** `enabled: false` switches the read off at the source, which is how the dev
 *  fixture harness renders a surface without a backend. */
export function useGetBrands(options: { enabled?: boolean } = {}) {
  const { selectedOrganization } = useSelectedOrganization();
  const orgId = selectedOrganization?.organization.id ?? null;

  return useQuery({
    queryKey: ["brands", orgId],
    queryFn: async () => {
      const res = await axiosInstance.get<Brand[]>(`/brand/all/${orgId}`);
      return res.data;
    },
    enabled: !!orgId && options.enabled !== false,
  });
}
